import { DocumentIcon, AudioIcon, VideoIcon } from '@shared/ui/icons';

/**
 * Presentational icon maps for resource types, keyed by backend
 * resourceType string (article | podcast | video).
 *
 * Two variants exist because the modal picker uses large icons
 * without a coloured background, while the table cell uses small
 * icons tinted with a semi-transparent background in the brand
 * palette associated with each resource type.
 */

const modalIcon = (Icon) => (
  <div
    style={{
      borderRadius: '50%',
      width: 38,
      height: 38,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Icon style={{ width: 24, height: 24 }} />
  </div>
);

const tableIcon = (Icon, color) => (
  <div
    style={{
      backgroundColor: color.replace(/\)$/, ', .1)'),
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 28,
      width: 28,
    }}
  >
    <Icon style={{ color, width: 20, height: 20 }} />
  </div>
);

/** Icons used in the resource-type picker step of the invitation modal. */
export const RESOURCE_ICON_LIST = {
  article: modalIcon(DocumentIcon),
  podcast: modalIcon(AudioIcon),
  video: modalIcon(VideoIcon),
};

/** Icons used inside table cells showing resource type per row. */
export const RESOURCE_ICON_LIST_FOR_TABLE = {
  article: tableIcon(DocumentIcon, 'rgba(236, 127, 1)'),
  podcast: tableIcon(AudioIcon, 'rgba(132, 21, 188)'),
  video: tableIcon(VideoIcon, 'rgba(249, 88, 135)'),
};
